import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface UpdateIntegrationInterface {
  azureSftp?: []
  partnerId?: string
  wooCommerce?: []
  shopify?: []
  pushApi?: []
}

export const useUpdateIntegration = () => {
  const mutate = useMutation(
    ({
      azureSftp,
      partnerId,
      wooCommerce,
      shopify,
      pushApi,
    }: UpdateIntegrationInterface) => {
      return postAPI('/facade/UpsertIntegration', {
        partnerId: partnerId,
        wooCommerce: wooCommerce,
        shopify: shopify,
        pushAPI: pushApi,
        /** BDL20-3004 — update-only; the API ignores entries without an id. */
        azureSftp: azureSftp,
      })
    },
  )

  return mutate
}

export default useUpdateIntegration
